import { render } from "./CheckComponentEditor.vue?vue&type=template&id=e6e2ed3c&scoped=true&ts=true"
import script from "./CheckComponentEditor.vue?vue&type=script&lang=ts"
export * from "./CheckComponentEditor.vue?vue&type=script&lang=ts"

import "./CheckComponentEditor.vue?vue&type=style&index=0&id=e6e2ed3c&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e6e2ed3c"]])

export default __exports__